module.exports = __webpack_public_path__ + "static/chain_shirt-d2520a4d631351d03428b84970c4988f.jpg";